import { render } from "./GallerySliderBlock.vue?vue&type=template&id=c3ec9500"
import script from "./GallerySliderBlock.vue?vue&type=script&lang=js"
export * from "./GallerySliderBlock.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__